// 阿拉伯语
// cSpell:disable
export const h = {
  case: {
    title: "إعدادات معلومات الحالة",
    name: "الاسم",
    coverImage: "صورة الغلاف",
    describe: "الوصف",
    uploadDesc: "انقر لتحميل الصورة، الحجم الموصى به هو (500*375)",
    shareLink: "مشاركة إعدادات الرابط",
    expiration: "لا تنتهي صلاحيتها",
    on: "مفتوح",
    off: "إغلاق",
    failureTime: "وقت الفشل",
    pickDay: "يرجى اختيار التاريخ",
    pickerOptions: {
      shortcuts: [
        {
          text: "بعد يوم واحد",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            return date;
          },
        },
        {
          text: "بعد اسبوع واحد",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            return date;
          },
        },
        {
          text: "بعد 30 يومًا",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            return date;
          },
        },
      ],
    },
    dateCannotEmpty: "لا يمكن أن يكون التاريخ فارغًا",
    nameCannotEmpty: "لا يمكن أن يكون الاسم فارغًا!",
    descCannotEmpty: "الوصف لا يمكن أن يكون فارغا!",
    logoSet: "إعدادات الشعار",
    selectAll: "اختر الكل",
    noBrand: "لا توجد علامة تجارية",
    openEffect: "تأثير الافتتاح",
    closeOpenMode: "لا شيء",
    asteroidOpen: "افتتاح الكويكب",
    horizontalOpen: "افتتاح العرض الأفقي",
    asteroidCruise: "افتتاح رحلة الكويكبات",
    Crystal: "افتتاح الكرة الكريستالية",
    asteroidScale: "افتتاح الكويكب Zoom",
    limitImage: "حجم الصورة كبير جدًا، يرجى الحد من حجم الصورة إلى 4M",
    imageType: "نوع الصورة خاطئ، يرجى تحميل الصورة بتنسيق png وjpg",
  },
  slide: {
    case: "قضية",
    save: "حفظ",
    view: "عرض",
    panorama: "بانوراما",
    angleView: "منظور النظر",
    hotspot: "نقاط ساخنة",
    music: "موسيقى",
    designer: "مصمم",
    beautify: "تجميل",
  },
  list: {
    title: "إعدادات قائمة بانوراما",
    draganoramicsort: "اسحب الفرز البانورامي",
    resetSort: "إعادة تعيين الفرز",
    addPanoramic: "أضف بانوراما",
    customThumbnailImages: "صور مصغرة مخصصة",
    more: "المزيد",
    downloadImage: "تحميل الصور البانورامية",
    replaceImage: "استبدال الصورة البانورامية",
    downloadImagePackage: "تحميل حزمة بانوراما",
    downloadDiagram: "تحميل مخطط القناة",
    ApplyThumbnailToImage: "تطبيق هذه الصورة المصغرة على صورة غلاف الحالة",
    VoiceBroadcast: "معلومات البث الصوتي",
    restoreImage: "استعادة الصورة البانورامية",
    uploadImage: "انقر لتحميل الصورة",
    upgradePackage: "حزمة الترقية",
    eidt: "تعديل بانوراما",
    name: "اسم بانوراما",
    thumbnail: "صورة مصغرة",
    enterName: "أدخل اسم بانوراما",
    uploadDesc: "انقر لتحميل الصورة، الحجم الموصى به هو (500*375)",
    confirm: "تأكيد",
    cannotEmpty: "لا يمكن أن يكون اسم البانوراما فارغًا",
    selectToAdd: "حدد بانوراما جديدة",
    selectAll: "حدد كل هذه الصفحة",
    StartAndEnd: "وقت البدء والانتهاء",
    schemeName: "اسم مخطط العرض",
    清晰度: "الوضوح",
    searchThisPlan: "الاستفسار وفقًا لهذا المخطط",
    search: "الاستعلام",
    empty: "لا توجد مشاهد مقدمة خلال الفترة الزمنية الحالية",
    dateOptions: {
      shortcuts: [
        {
          text: "اليوم",
          value() {
            const end = new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            );
            const start = new Date(
              new Date(new Date().toLocaleDateString()).getTime()
            );
            return [start, end];
          },
        },
        {
          text: "منذ 3 أيام",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            return [start, end];
          },
        },
        {
          text: "منذ اسبوع",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: "منذ 30 يومًا",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: "منذ 90 يومًا",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          },
        },
      ],
    },
    loading: "تحميل...",
    sceneAlreadyExists: "هذا المشهد موجود بالفعل في قائمة البانوراما الحالية",
    previewImage: "البانوراما الحالية عبارة عن معاينة سريعة",
    applyToThumbnail: "تطبيق على الصور المصغرة",
    delete: "حذف",
    content:
      "سيؤدي حذف هذا المشهد إلى حذف النقاط الساخنة التي تشير إلى المشهد في المشاهد الأخرى. هل تريد مواصلة الحذف؟",
    captureScreen: "التقاط لقطات من الشاشة",
    generateScreenshots: "إنشاء لقطة شاشة",
    thumbnailApply:
      "تم تطبيق الصورة المصغرة بنجاح وتصبح سارية المفعول بعد الحفظ",
    atLeastOne: "يرجى الاحتفاظ بمشهد واحد على الأقل ~",
    downloadCompleted: "اكتمل التنزيل!",
    fielDownloadFailed: "فشل تنزيل الملف!",
    limitImageSize:
      "حجم الصورة كبير جدًا، يرجى الحد من حجم الصورة حتى لا يتجاوز",
    imageType: "نوع الصورة خاطئ، يرجى تحميل الصورة بتنسيق png وjpg",
    imageAspectRatio: "يرجى تحميل نسبة العرض إلى الارتفاع على",
    replaceFailed: "فشل الاستبدال، يرجى المحاولة مرة أخرى",
    uploadFailed: "فشل التحميل، يرجى المحاولة مرة أخرى",
    restoreFailed: "فشل الاستعادة",
    applySuccess: "تم تطبيقه بنجاح ويدخل حيز التنفيذ بعد الحفظ",
    dateCannotEmpty: "لا يمكن أن يكون التاريخ فارغًا",
    全部: "كلها",
    快速预览: "معاينة سريعة",
  },
  camera: {
    rotationSettings: "إعدادات الدوران",
    turnOnRotation: "تشغيل الدوران",
    waitTime: "وقت الانتظار (ثانية)",
    clickSettings: "الإعدادات",
    rotationInfoBefore:
      "هل تؤكد تطبيق حالة الدوران الحالية على قائمة المشاهد الحالية",
    rotationInfoAfter: "المشهد وحفظه؟",
    cameraSettings: "عدسة",
    recently: "الحديث: الحد الأدنى لمجال العرض عند تكبير المشهد",
    initial: "أولي: أدخل مجال الرؤية الأولي للمشهد",
    farthest: "أبعد: الحد الأقصى لمجال العرض عند تكبير المشهد",
    recommended: "الإعدادات الموصى بها: أقرب 70، أولي 95، أبعد 125",
    viewingAngle: "نطاق زاوية الرؤية",
    recentlyt: "مؤخرا",
    initialt: "أولية",
    farthestt: "أبعد",
    viewInfoFirst: "أنت تؤكد أن مجال الرؤية الحالي (الأخير:",
    viewInfoSecend: ") المطبقة على قائمة المشهد الحالية",
    viewInfoThird: "المشهد وحفظه؟",
    inCommonUse: "تعيين شائع",
    reset: "ترميم",
    stapleInfo: "حفظ نطاق زاوية العرض الحالي كعدسة عادية",
    commonLenses: "شائع الاستخدام",
    systemLens: "عدسة النظام",
    restoreInfo: "استعادة القيمة الأولية لمجال الرؤية للمشهد الحالي",
    restoreDefault: "استعادة الافتراضي بنجاح",
    recommendedLens:
      "استخدم العدسة الموصى بها بنجاح وتصبح سارية المفعول بعد الحفظ",
    usedLenses: "استخدم عدسة شائعة الاستخدام بنجاح ويدخل حيز التنفيذ بعد الحفظ",
    initialViewpoint:
      "تم إعداد زاوية المشاهدة الأولية بنجاح وتدخل حيز التنفيذ بعد",
    setCommonLens: "تم إعداد العدسات الشائعة بنجاح",
    initialPerspective: "قم بتعيين المنظور الأولي",
  },
  hotspot: {
    addHotspots: "نقطة ساخنة جديدة",
    clear: "إفراغ",
    clearHotspots: "مسح النقاط الساخنة",
    clearHotspotsForCurrentScene: "مسح قائمة النقاط الساخنة للمشهد الحالي",
    editHotspots: "تحرير نقاط الساخنة",
    return: "العودة",
    hotspotType: "نوع النقاط الساخنة",
    type: "أنواع",
    hotspotList: "قائمة النقاط الساخنة للمشهد الحالي",
    all: "كلها",
    navigation: "الملاحة",
    link: "ارتباط تشعبي",
    image: "صور",
    deleteHotspot: "تأكيد حذف هذه النقطة الساخنة",
    style: "النمط",
    hotspotName: "اسم نقطة ساخنة",
    name: "الاسم",
    enterHotspotName: "يرجى إدخال اسم نقطة الساخنة",
    targetPanorama: "بانوراما الهدف",
    ok: "تأكيد",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    confirmDelete: "تأكيد حذف هذه النقطة الساخنة",
    hotspotImage: "صور ساخنة",
    uploadImage: "انقر لتحميل الصورة",
    editImage: "تعديل الصورة",
    addImage: "أضف صورة",
    hotspotAddress: "عنوان نقطة ساخنة",
    address: "العنوان",
    targetUrl: "يرجى إدخال URL الوجهة",
    videoAddress: "عنوان الفيديو",
    videoUrl: "يرجى إدخال URL للفيديو",
    targetNoEmpty: "لا يمكن أن يكون المشهد المستهدف فارغًا",
    noTarget: "لا يوجد مشهد مستهدف بعد",
    hotspotNameNoEmpty: "لا يمكن أن يكون اسم النقطة الساخنة فارغًا",
    hotspotDetailNoEmpty: "لا يمكن أن تكون تفاصيل النقاط الساخنة فارغة",
    linkNoEmpty: "لا يمكن أن يكون عنوان الرابط فارغًا",
    linkIncorrect: "تنسيق عنوان الرابط غير صحيح",
    videoNoEmpty: "لا يمكن أن يكون عنوان رابط الفيديو فارغًا",
    pleaseUploadImage: "يرجى تحميل الصور الساخنة أولاً",
    limitImage: "حجم الصورة كبير جدًا، يرجى الحد من حجم الصورة إلى أكثر من 30M",
    uploadFailed: "فشل التحميل، يرجى المحاولة مرة أخرى",
    uploadSuccessful: "تم التحميل بنجاح",
    imageType: "نوع الصورة خاطئ، يرجى تحميل الصورة بتنسيق png وjpg",
    noHotSpots: "لا توجد نقاط ساخنة في المشهد الحالي",
    text: "نص",
    video: "فيديو",
    hotspotDetail: "التفاصيل الساخنة",
    detail: "التفاصيل",
    noOtherScene: "لا يوجد مشهد آخر",
    enterHotspotDetail: "يرجى إدخال تفاصيل نقطة الاتصال",
    videoResources: "موارد الفيديو",
    clickToSwitch: "انقر للتبديل",
    clickUploadVideo: "انقر لتحميل الفيديو",
    videoFormat: "دعم تنسيق MP4، لا يتجاوز الحد الأقصى 100M",
    enerVideoUrl: "يرجى إدخال URL للفيديو",
  },
  music: {
    musicSettings: "إعدادات الموسيقى",
    trialListening: "الاختبار",
    stopListening: "توقف عن الاستماع",
    setMusic: "إعداد الموسيقى",
    backgroundMusic: "موسيقى الخلفية",
    SystemMusicLibrary: "مكتبة موسيقى النظام",
    selected: "تم اختياره",
    myMusic: "موسيقاي",
    uploadMusic: "تحميل الموسيقى",
    upgradePackage: "حزمة الترقية",
    uploadAgree: "قم بالتحميل وافق",
    disclaimer: "يرجى تحديد إخلاء المسؤولية أولاً",
    musicName: "يرجى إدخال اسم الموسيقى",
    deleteMusic: "احذف الموسيقى",
    noCustomMusic: "لا توجد موسيقى مخصصة بعد",
    onlineMusic: "الموسيقى عبر الإنترنت",
    operationProcess: "عملية التشغيل",
    oneStep:
      "ابحث عن رابط الصوت الصحيح وأدخل رابط الصوت في حقل إدخال المتصفح، وإذا كان من الممكن تشغيله أو تنزيله، فهو عادة رابط الصوت الصحيح؛",
    twoStep: "لصق رابط الصوت في حقل الإدخال أعلاه؛",
    threeStep:
      "انقر فوق زر موافق أولاً، ثم انقر فوق الزاوية اليسرى العليا للحفظ.",
    ok: "تأكيد",
    placeholderInfo: "أدخل عنوان الموسيقى عبر الإنترنت وتأكد من توافر الموسيقى",
    musicAddress: "يرجى إدخال عنوان الموسيقى",
    limitMusic:
      "عنوان الموسيقى طويل جدًا، يرجى الحد من طول العنوان إلى 150 حرفًا",
    saveMusic: "يرجى اختيار الموسيقى قبل حفظها",
    linkIncorrect: "تنسيق عنوان الرابط غير صحيح",
    musicNonEmpty: "لا يمكن أن يكون اسم الموسيقى فارغًا",
    eidtFailed: "فشل التعديل",
    deleteSuccess: "حذف بنجاح",
    deleteFailed: "فشل الحذف",
    limitNameCharacter: "اسم الملف يتجاوز 50 حرفًا، يرجى تعديله قبل التحميل",
    limitFileSize: "الملف كبير جدًا، يرجى تقييد الملف إلى أكثر من 10 ميجا",
    limitFileType: "تنسيق الملف خاطئ، يرجى تحميل ملف بتنسيق mp3 أو wav",
    limitFileNumber: "الكثير من الملفات، الحد الأقصى لتحميل 30 ملفًا",
    uploadFailed: "فشل التحميل، يرجى المحاولة مرة أخرى",
    uploadSuccessful: "تم التحميل بنجاح",
    disclaimerInfo: "إخلاء المسؤولية",
  },
  design: {
    designerInfo: "إعدادات معلومات المصمم",
    name: "الاسم",
    enterName: "ادخل الاسم",
    phone: "الهاتف",
    enterPhone: "ادخل الهاتف",
    avater: "صورة رمزية",
    uploadImageInfo: "انقر لتحميل الصورة، الحجم الموصى به هو (64*64)",
    nameNonEmpty: "لا يمكن أن يكون الاسم فارغًا!",
    phoneNonEmpty: "لا يمكن أن يكون الهاتف فارغًا!",
    phoneNumber: "الرجاء إدخال رقم الهاتف الصحيح!",
    limitImage: "حجم الصورة كبير جدًا، يرجى الحد من حجم الصورة إلى 4M",
    imageType: "نوع الصورة خاطئ، يرجى تحميل الصورة بتنسيق png وjpg",
  },
  beauty: {
    filterSet: "إعدادات المرشح",
    colorSet: "إعدادات الألوان",
    brightness: "سطوع",
    contrastRatio: "نسبة التباين",
    saturation: "التشبع",
    hue: "اللون",
    restoreDefault: "استعادة الافتراضي",
    compareOriginalImage: "مقارنة مع الصورة الأصلية",
    originalImage: "اضغط مع الاستمرار لإظهار الصورة الأصلية",
    noFilter: "بدون فلتر",
    warmYellow: "أصفر دافئ",
    romanticPurple: "أرجواني رومانسي",
    modernGrey: "رمادي حديث",
    restoreSuccessful: "استعادة الافتراضي بنجاح",
  },
  tipInfo: {
    tip: "تلميحات",
    switchNavigation: "تحويل الملاحة",
    fillCorrectly: "يرجى ملئه بشكل صحيح",
    panoramaEditor: "محرر بانوراما",
    editSave: "يرجى تحريرها وحفظها",
    viewSave: "لا يزال لديك معلومات غير محفوظة، يرجى حفظها أولاً ثم عرضها",
    saveView: "حفظ عرض",
    save: "قيد الحفظ",
    saveSuccess: "حفظ بنجاح",
    请填写必填项后再进行编辑: "يرجى ملء الحقول المطلوبة قبل التعديل",
  },
  loading: {
    schemeLoading: "سيناريو التحميل...",
    loadingTitle: "ملتزمون بأن نكون أفضل منصة متكاملة لتصميم المنزل",
    loadingStrives: "تسعى Tiangong Smart Home جاهدة لإنشاء",
  },
  driver: {
    案例详情: "تفاصيل الحالة",
    修改全景名称描述等:
      "قم بتعديل اسم البانوراما والوصف وما إلى ذلك، وقم بتعيين وقت انتهاء صلاحية البانوراما، والتحكم في عرض شعار العلامة التجارية، وما إلى ذلك.",
    下一步: "الخطوة التالية",
    上一步: "الخطوة السابقة",
    关闭: "إغلاق",
    完成: "اكتمل",
    全景列表: "قائمة بانوراما",
    增加删除修改场景:
      "إضافة المشاهد وحذفها وتعديلها وتنزيل الصور البانورامية واستبدال الصور المصغرة البانورامية وتعديل أسماء البانوراما وما إلى ذلك.",
    视角设置: "إعدادات زاوية الزاوية",
    设置全景是否开启自动旋转:
      "اضبط ما إذا كان يتم تشغيل الدوران التلقائي للبانوراما؛ معلومات زاوية الرؤية الأولية للبانوراما ، إلخ.",
    热点设置: "إعدادات نقطة الساخنة",
    增加新的热点或修改已有热点:
      "إضافة نقاط ساخنة جديدة أو تعديل نقاط ساخنة موجودة.",
    设置音乐: "إعداد الموسيقى",
    设计师信息设置: "إعدادات معلومات المصمم",
    设置设计师头像姓名:
      "تعيين الصورة الرمزية للمصمم والاسم ومعلومات الاتصال وغيرها من المعلومات.",
    美化设置: "إعدادات التجميل",
    设置全景滤镜效果:
      "قم بتعيين تأثير مرشح بانورامي؛ تعديل سطوع الألوان البانورامية والتباين واللون وما إلى ذلك.",
  },
  video: {
    视频转换: "تحويل الفيديو",
    上传视频: "تحميل الفيديو",
    视频格式错误请重新上传视频将转码转码时无法使用全景其他功能:
      "تنسيق الفيديو غير صحيح، يرجى إعادة تحميله. سيتم تحويل ترميز الفيديو، ولا يمكن استخدام وظائف بانورامية أخرى أثناء تحويل الترميز.",
    支持MP4格式最大不超过300M: "دعم تنسيق MP4، لا يتجاوز الحد الأقصى 300M",
    上传视频编码错误请重新上传:
      "تم تحميل ترميز الفيديو بشكل خاطئ، يرجى تحميله مرة أخرى",
    视频转换中: "تحويل الفيديو",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/lan/ar.js